import { render, staticRenderFns } from "./SettingBlockBase.vue?vue&type=template&id=1fab8ed6&scoped=true&"
import script from "./SettingBlockBase.vue?vue&type=script&lang=js&"
export * from "./SettingBlockBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab8ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fab8ed6')) {
      api.createRecord('1fab8ed6', component.options)
    } else {
      api.reload('1fab8ed6', component.options)
    }
    module.hot.accept("./SettingBlockBase.vue?vue&type=template&id=1fab8ed6&scoped=true&", function () {
      api.rerender('1fab8ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/SettingBlockBase.vue"
export default component.exports